<template>
  <div class="teacher wallet-success">
    <van-icon name="checked" color="var(--c2)" size="100" />
    <p class="tips">开通成功</p>
    <p>复制链接，登录电脑端进行对账</p>
    <van-field
      center
      clearable
      readonly
      class="extend-filed"
    >

      <template #input>
        <input 
        type="text" 
        v-model="extendUrl" 
        readonly="readonly" 
        ref="copyInput"
        placeholder="请输入短信验证码" 
        class="van-field__control">
      </template>
      <template #button>
        <van-button type="primary"  @click="copyUrl">复制</van-button>
      </template>
    </van-field>
  </div>
</template>

<script>
export default {
  data () {
    return {
      pageTitle: '收费管家',
      extendUrl: 'https://b.xiaogj.com/mchweb/#/login',
    }
  },
  methods: {
    copyUrl() {
        this.$refs.copyInput.select();
        this.$refs.copyInput.setSelectionRange(0, this.extendUrl.length);
        document.execCommand('copy');
        vant.Toast.success('复制成功');
        this.$refs.copyInput.blur();
    },
  }
}
</script>

<style lang="scss">
.teacher.wallet-success{
  text-align: center;
  padding: calc(var(--gap) * 40) 0 0;
  background: var(--white);
  .tips{
    margin: 0 0 calc(var(--gap) * 40) 0;
    font-size:var(--fs-lg);
    line-height:var(--lh-lg);
    font-weight: var(--bold);
  }
  .extend-filed{
    margin: 0;
    padding: 0 16px;
    .van-field__body{
      padding-left: 16px;
      height: 44px;
      background: var(--g1);
      border-radius: 22px;
      input{
        font-size: var(--fs-lg);
        &::selection {
            color: var(--g8);
            background: transparent;
        }
      }
      .van-field__button{
        .van-button--normal{
          height: 44px;
          border-radius: 0 22px 22px  0;
        }
      }
    }
  }
}
</style>